import { format } from 'date-fns';
/** Formate une date (string ISO ou Date) en dd/MM/yyyy pour l'affichage */
export function formatDateDisplay(value) {
    const date = value instanceof Date ? value : new Date(value);
    return format(date, 'dd/MM/yyyy');
}
/** Convertit un Date en string YYYY-MM-DD timezone-safe (utilise le fuseau local) */
export function toDateOnlyString(date) {
    const d = date instanceof Date ? date : new Date(date);
    return format(d, 'yyyy-MM-dd');
}
const naturalDateFormatter = new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});
/** Formate une date (string ISO ou Date) au format naturel français, ex: "12 juillet 2026" */
export function formatDateNatural(value) {
    const date = value instanceof Date ? value : new Date(value);
    return naturalDateFormatter.format(date);
}
